/**
 * @generated SignedSource<<d6b738d5eeeeb9ab03f6fb657a78180a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterArtSize_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilterArtSize_itemSearch">;
  readonly " $fragmentType": "SbRespRefineMenuFilterArtSize_itemSearch";
};
export type SbRespRefineMenuFilterArtSize_itemSearch$key = {
  readonly " $data"?: SbRespRefineMenuFilterArtSize_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuFilterArtSize_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuFilterArtSize_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterArtSize_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "3eb1e48e75ae61d582adaad607c7c2ef";

export default node;
